module.exports = __webpack_public_path__ + "img/pontotel-novo-branco.00251a85.png";